/* jshint esversion: 6 */

/***********************************************************************
 LoggingService
 ***********************************************************************/

const consoleLogger = {
    logInfo : function( logId, msg ){
        console.log( (logId ? `${logId}: ` : "") + msg);
    },
    logWarning : function( logId, msg ){
        console.warn( (logId ? `${logId}: ` : "") + msg);
    },
    logError : function( logId, msg ){
        console.error( (logId ? `${logId}: ` : "") + msg);
    }
};

class Logger {

    constructor(){
        this.logger = consoleLogger;
    }

    log( msg, logId ){
        this.logger.logInfo( logId, msg );
    }

    warning( msg, logId ){
        this.logger.logWarning( logId, msg );
    }

    error( msg, logId ){
        this.logger.logError( logId, msg );
    }
}

export const LoggingService = new Logger();
